module.exports = __webpack_public_path__ + "07_medium_gold.ddcda809.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_medium_gold.png
// module id = +9WO
// module chunks = 0